import api from "./API";

// Courses
export const GetUserCourses = async (packageId: number) =>
  (await api.get(`Courses?PackageId=${packageId}`)).data;

export const AddUpdateCourse = async (userData: any) =>
  (await api.patch("Courses/AddUpdate", userData, {
    headers: { "Content-Type": "multipart/form-data" },
  })).data;

export const GetPackages = async () =>
  (await api.get("Courses/Packages")).data;

export const GetCourseDetails = async (courseId: number) =>
  (await api.get(`Courses/CourseDetail?courseId=${courseId}`)).data;

export const GetLearningUrl = async (userData: any) =>
  (await api.post("Courses/CourseVideo", userData)).data;

export const LearningCourse = async (userData: any) =>
  (await api.post("Courses/LearningCourse", userData)).data;

export const FirstStepUpdate = async (userData: any) =>
  (await api.put("Courses/FirstStep", userData)).data;

export const AddUpdateCourseQuestionsAsync = async (userData: any) =>
  (await api.put("Courses/CourseQuestion", userData)).data;

export const GetCourseQuestionAsync = async (courseId: number) =>
  (await api.get(`Courses/GetCourseQuestion?courseId=${courseId}`)).data;

export const GetCoursesOrderAndAction = async (userData: any) =>
  (await api.patch("Courses/GetCoursesOrderAndAction", userData)).data;

export const GetCoursesForExam = async (userData: any) =>
  (await api.post("Courses/GetCourseQuestion", userData)).data;

export const GetCourseList = async (userData: any) =>
  (await api.post("Courses/CourseList", userData)).data;
